export const useDownload = () => {
  const download = (url, filename) => {
    fetch(url)
      .then((res) => res.blob())
      .then((blob) => {
        const link = document.createElement('a');
        link.href = URL.createObjectURL(blob);
        link.download = filename || 'file';
        link.click();
        URL.revokeObjectURL(link.href);
      })
      .catch((err) => {
        console.error('Download error:', err);
      });
  };

  return download;
};